var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 798,
    viewBox: "0 0 484 798",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1718 367.982L367.846 13.3261C384.945 -3.77342 412.684 -3.77342 429.784 13.3261L471.155 54.6971C488.236 71.7784 488.254 99.4443 471.228 116.562L190.135 398.951L471.209 681.358C488.254 698.475 488.218 726.141 471.136 743.223L429.765 784.594C412.666 801.693 384.927 801.693 367.827 784.594L13.1718 429.92C-3.92772 412.82 -3.92772 385.081 13.1718 367.982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.115bb0463a067bc834a898fa4ff4ab0a.svg";
export { ForwardRef as ReactComponent };